import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "../ui/select";

interface SelectComponentProps {
    options: { label: string; value: string }[];
    onChange: (value: string) => void;
    placeholder: string;
    defaultValue?: string;
}

const SelectComponent = ({ options, onChange, placeholder, defaultValue }: SelectComponentProps) => {
    return (
        <Select onValueChange={onChange} defaultValue={defaultValue}>
            <SelectTrigger className="w-[180px]">
                <SelectValue placeholder={placeholder} />
            </SelectTrigger>
            <SelectContent>
                {options.map((option) => (
                    <SelectItem
                        key={option.value}
                        value={option.value}
                        className="cursor-pointer bg-white hover:bg-gray-100"
                    >
                        {option.label}
                    </SelectItem>
                ))}
            </SelectContent>
        </Select>

    )
}

export default SelectComponent;